import { forwardRef, ForwardRefRenderFunction } from 'react'
import {
  DatePicker as MUIDatePicker,
  DatePickerProps as MUIDatePickerProps,
  LocalizationProvider,
  PickersDay
} from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { DSInputType } from 'components'
import { TextFieldStyled } from '../Input/styles'
import * as S from './styles'
import 'moment/locale/pt-br'

export type DatePickerProps<T> = {
  error?: string | null
  errorState?: boolean
  required?: boolean
  height?: number
  placeholder?: string
} & Omit<MUIDatePickerProps<T, T>, 'renderInput'>

// TODO: Replace momentjs with dayjs

const DatePickerComponent: ForwardRefRenderFunction<
  HTMLInputElement,
  DatePickerProps<string>
> = ({ error, errorState, required, height = 40, placeholder, ...props }, ref) => {
  const hasError = Boolean(error)

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <S.StyleWrapper>
        <MUIDatePicker
          {...props}
          showDaysOutsideCurrentMonth
          desktopModeMediaQuery="(min-width: 600px)"
          renderInput={({ name, label, ...params }) => (
            <S.TextFieldWrapper>
              {label && (
                <S.LabelWrapper disabled={params.disabled}>
                  <label id="LabelInputForm" htmlFor={name}>
                    {label}
                  </label>
                </S.LabelWrapper>
              )}
              <TextFieldStyled
                id={name}
                inputRef={ref}
                name={name}
                height={height}
                required={required}
                design={DSInputType.MASTER_INPUT}
                {...params}
                error={hasError || errorState}
                helperText={error}
                inputProps={{
                  ...params.inputProps,
                  placeholder: placeholder ?? params.inputProps?.placeholder
                }}
              />
            </S.TextFieldWrapper>
          )}
          renderDay={(_, __, pickerDayProps) => (
            <S.PickersDayWrapper key={pickerDayProps.key}>
              <PickersDay {...pickerDayProps} />
            </S.PickersDayWrapper>
          )}
          OpenPickerButtonProps={{ color: 'primary' }}
          PaperProps={{
            style: {
              textTransform: 'capitalize'
            }
          }}
          InputProps={{
            size: 'small'
          }}
        />
      </S.StyleWrapper>
    </LocalizationProvider>
  )
}

export const DatePicker = forwardRef(DatePickerComponent)
